import { ChangeEvent, memo, useCallback, useEffect, useState } from "react";
import { Security } from "../../../../proto/generated/security";
import { IconButton } from "@mui/material";
import ExtraSmallTextField from "../../../common/ExtraSmallTextField";
import { AddRounded, RemoveRounded } from "@mui/icons-material";

export type QuantityCellProps = {
    security: Security,
    quantity: number,
    disabled?: boolean,
    onChange?: (quantity: number) => void
}

const QuantityCell: React.FC<QuantityCellProps> = ({quantity, security, disabled, onChange}) => {
    const [quantityValue, setQuantityValue] = useState<number | string>(quantity);

    const onInputQuantityChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        setQuantityValue(event.currentTarget.value);
    }, [])

    useEffect(() => {
        quantity && setQuantityValue(quantity);
    }, [quantity])

    const onInputBlur = useCallback(() => {
        if(Number(quantityValue)<=0) {
            setQuantityValue(security.lotSize)
        }
        onChange(Number(quantityValue))
    }, [security, quantityValue, onChange])

    const onQuantityIncrease = useCallback(() => {
        const newQuantity = quantity + (security.lotSize??1);
        newQuantity <= security.volumeFreezeQuantity && onChange(quantity + (security.lotSize??1))
    }, [quantity, security])

    const onQuantityDecrease = useCallback(() => {
        const newQuantity = quantity - (security.lotSize??1)
        newQuantity > 0 && onChange(quantity - (security.lotSize??1))
    }, [quantity, security])

    const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            (e.target as any)?.blur()
        }
    }, []);

    return  <ExtraSmallTextField
                textFieldProps={{
                    id: 'quantity-textfield',
                    hiddenLabel: true,
                    className: 'rounded',
                    onChange: onInputQuantityChange,
                    onBlur: onInputBlur,
                    type: 'number',
                    disabled: disabled,
                    value: quantityValue,
                    inputProps: {
                        sx: {
                            maxWidth: 32
                        },
                        step: 1,
                        min: 0,
                        inputMode: 'numeric',
                        pattern: '[0-9]*'
                    },
                    InputProps: {
                        startAdornment: (<IconButton
                            onClick={onQuantityDecrease}
                            disabled={disabled}
                            size={'small'} sx={{ p: 0 }}><RemoveRounded
                                className="trade-panel-edit-icons" /></IconButton>),
                        endAdornment: (<IconButton
                            onClick={onQuantityIncrease}
                            disabled={disabled}
                            size={'small'}
                            sx={{ p: 0 }}><AddRounded
                                className="trade-panel-edit-icons" /></IconButton>)
                    },
                    onKeyDown: handleKeyDown
                }}
            />
}

export default memo(QuantityCell);